
import {React, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router";
//import Sidebar from "../../components/Sidebar";
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { useQuery, gql } from '@apollo/client';
import UserContext from '../../../../context/UserContext';
import { Link , useNavigate} from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button"; 
import { Paginator } from 'primereact/paginator';
import "../../../../index.css"
import HotelDtlMainCoop from './HotelDtlMainCoop'
import HotelCreateCoop from './HotelCreateCoop'
import { Dialog } from 'primereact/dialog';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';



//theme
import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
import "primereact/resources/primereact.min.css";                                       
        


const GET_POST = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
  ) {
    tbl_firm_main_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        firm_main_type_n: { _eq: "HTL"}
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_main_name_n
      firm_main_type_n
      int_ID
    }
  }
`;





const items = [{ label: 'Dashboard' ,url: "/", target: '_self'}, { label: 'Administrator' ,url:"/agn/agency-adm/main" }, { label: 'Managing Hotel' }];


const HotelListCoop = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { users } = useContext(UserContext);
  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {
      ownFirmMainCode,
      ownFirmSubCode,
      ownFirmSubType,
    },
  });


  const lang = users.userLang;
  const intl = useIntl();
  const currentLocale = "ru"; 
  const close_form = messages[currentLocale].close_form;
  const new_firm = messages[currentLocale].new_firm;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const typerec = messages[currentLocale].typerec;
  const placerec = messages[currentLocale].placerec;
  const time_zone = messages[currentLocale].time_zone;
  const update_firm = messages[currentLocale].update_firm;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create = messages[currentLocale].create;
  const update = messages[currentLocale].update;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const definitions = messages[currentLocale].definitions;
  const managing_hotel = messages[currentLocale].managing_hotel;
  const firm_detail = messages[currentLocale].firm_detail;
  const agency_detail = messages[currentLocale].agency_detail;
  const sub_agency_detail = messages[currentLocale].sub_agency_detail;
  const main_department_tab = messages[currentLocale].main_department_tab;
  const sub_department_tab = messages[currentLocale].sub_department_tab;
  const rulesrec = messages[currentLocale].rulesrec;
  const account_cart_tab = messages[currentLocale].account_cart_tab;
  const bank_accounts_tab = messages[currentLocale].bank_accounts_tab;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_name = messages[currentLocale].sub_department_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const dpr_update_successfully = messages[currentLocale].dpr_update_successfully;

  const firm_main_code = messages[currentLocale].firm_main_code;
  const firm_sub_code = messages[currentLocale].firm_sub_code;
  const firm_sub_name = messages[currentLocale].firm_sub_name;

  const items = [{ label: dashboard ,url: "/", target: '_self'}, { label: administrator ,url:"/agn/agency-adm/main" }, { label: managing_hotel }];
  
  
  const [displayBasic, setDisplayBasic] = useState(false);
  const navigate = useNavigate();
 
  console.log(users.firmcode);

  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0); // first1'i tanımlayın ve başlangıç değeri ayarlayın

const onRowsPerPageChange = (e) => {
  setRows1(e.value); // Görünen kayıt sayısını değiştir
  setFirst1(0); // İlk sayfadan başla
};

const onPageChange = (e) => {
  setFirst1(e.first);
  setRows1(e.rows1);
}

const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />; // paginatorLeft'i tanımlayın
const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />; // paginatorRight'ı tanımlayın

  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredFirms = data.tbl_firm_main_coop.filter((firm) =>
    firm.firm_main_name_n.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const actionTemplate = (rowData) => {
    refetch();
    return (
      <Link to={`/agn/agency-adm/firm/hoteldtlmain-coop/${rowData.firm_main_code_n}`}>
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
      </Link>
      
    );
      };
      
       
      
      const onClick = () => {
        setDisplayBasic(true);
        refetch();
      };
      
      const onHide = () => {
        setDisplayBasic(false);
        
      };


  const userAndCreatedAtTemplate = (rowData) => {
    return (
      <div>
        <div className="text-xs">{rowData.create_user}</div>
        <div className="text-xs">{rowData.created_at}</div>
      </div>
    );
  };

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  return (

    

    
    
    
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-2 w-5/6">
        <nav>
          <ul className="flex border-solid rounded-md border-b outline-1">
            {items.map((item, index) => (
              <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
                {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
                {item.url ? (
                  <Link to={item.url}>{item.label}</Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="col-span-1 mr-5 flex justify-end">
     
      <button onClick={() => navigate(-1)} className="text-violet-900 hover:text-violet-200 font-bold">{close_form}</button>
   
      </div>
     
  
<Dialog visible={displayBasic} style={{ width: '50vw' }} onHide={onHide}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
      <HotelCreateCoop/>
    </p>
  </div>
</Dialog>
</div>
          
<div className="card flex ">      
<div className="container p-2 mx-auto ">
      <div className=" w-1/1 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border rounded-md"
          placeholder={search_by_firm_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      

      <div className="mt-0 flex  w-full justify-end ">
        <Button label={new_firm} aria-label="Create" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-purple-950
           text-white font-semibold  rounded-md"
          onClick={onClick}  
        />
        </div>
        </div></div></div>
      <div>
      <div className="card p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
        scrollable scrollHeight="450px" loading={loading}
        value={filteredFirms}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={currentPageReportTemplate}
        rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
        rowsPerPageOptions={[10, 20, 50]}
        first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
        onPage={(e) => setFirst1(e.first)} 
        onRowsPerPageChange={(e) => setRows1(e.value)}
      //  paginatorLeft={paginatorLeft}
      //  paginatorRight={paginatorRight}
        tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
        onPageChange={onPageChange}
        
        >
          <Column className="font-bold text-xs" field="firm_main_code_n" header={firm_code}></Column>
          <Column className="text-xs" field="firm_main_name_n" header={<span sortable className="font-bold text-gray-900">{firm_name}</span>}></Column>
          <Column className="text-xs" field="firm_main_type_n" style={{ textAlign: 'center', width: '7rem' }} header={<span className="font-bold text-gray-900">{firm_type}</span>}></Column>
          
          
          <Column field="firm_main_place_n"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{placerec}</span>}
           style={{ textAlign: 'right', width: '6rem' }}
          >
          </Column>
          <Column field="int_ID" className="font-bold text-xs" header={<span className="font-bold text-gray-900">{int_id}</span>}></Column>
          
          <Column
            body={userAndCreatedAtTemplate}
            header={<span className="font-bold text-xs text-gray-900">{create}</span>}
            style={{ textAlign: 'right', width: '6rem' }}
          />
           <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
          <Column
            body={actionTemplate}
            header={<span className="font-bold text-gray-900">{detail}</span>}
            
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
    
        </DataTable>
        
      </div>
    </div>
    </div>
 
  );
};

export default HotelListCoop;




